export class AgrarianInstructionalDivisionFilter {
  id: number;
  name: string;
  nameEN: string;
  nameSI: string;
  nameTA: string;

}
